import {
  commonStyles,
  createStyles,
  STYLE_SIZE_CONSTANTS,
  type StylesClasses,
} from '@utils/styles'

export const ComparePlanWidth = 316
export const ComparePlanGap = 16

const styles = createStyles({
  billingToggleWrapper: {
    padding: '8px 16px',
    backgroundColor: 'background.default',
    boxShadow: '0px 4px 16px 4px rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexWrap: 'nowrap',
    width: {
      xs: '100%',
      sm: 'fit-content',
    },
    alignItems: 'center',
    borderRadius: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.light',
    marginTop: '32px',
    marginBottom: '24px',
    marginLeft: 'auto',
  },

  billingButton: {
    border: 'none',
    padding: '5px 10px',
    borderRadius: '8px',
    minWidth: {
      xs: '80px',
      sm: '176px',
    },
    '&:hover': {
      border: 'none',
      backgroundColor: 'none !important',
    },
  },

  annualBillingLayout: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  annualChip: {
    borderRadius: '1260px',
    '& .MuiChip-label': {
      paddingInline: '0px !important',
    },
  },
  textField: {
    alignSelf: 'flex-end',
    maxWidth: '110px',
    maxHeight: '40px',
    '.MuiInputBase-root': {
      maxHeight: '40px !important',
    },
    display: {
      xs: 'block',
      sm: 'none',
    },
  },
  filterWrapper: {
    ...commonStyles.flexSpace(),
    display: {
      xs: 'flex',
      sm: 'none',
    },
  },
  tableStickyHeader: {
    display: {
      xs: 'flex',
      sm: 'flex',
    },
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    position: 'sticky',
    top: STYLE_SIZE_CONSTANTS.headerHeight,
    borderRadius: '4px',
    backgroundColor: 'background.paper',
    zIndex: 10,
    paddingBottom: '0px',
  },
  tableWrapper: {
    position: 'relative',
  },
  premiumColumnHighlight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    // Position for Premium column (middle of 3 plan columns)
    // Right position from right edge: Enterprise column (316px) + Padding (16px) + Gap (16px)
    right: {
      sm: `calc(${ComparePlanWidth}px + 16px + ${ComparePlanGap}px)`,
    },
    width: {
      xs: '100px',
      sm: `${ComparePlanWidth}px`,
    },
    backgroundColor: 'rgba(67, 56, 202, 0.06)',
    borderRadius: '16px',
    zIndex: 0,
    pointerEvents: 'none',
    border: '2px solid',
    borderColor: 'primary.main',
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
  planChangeFiled: {
    ...commonStyles.textField,
    maxWidth: 'fit-content',
    alignSelf: 'center',
    marginLeft: 'auto',
    minWidth: '100px',
    maxwidth: '100px',
    '& .MuiInputBase-root': {
      padding: '0.5rem 0.5rem',
      paddingLeft: '0rem',
      height: '40px',
    },
  },
  planHeaderItem: {
    height: '100%',
    minHeight: {
      xs: 'unset',
      sm: '160px',
    },
    width: {
      xs: '100px',
      sm: `${ComparePlanWidth}px`,
    },
    padding: '16px',
    position: 'relative',
  },
  premiumPlanHeader: {
    backgroundColor: {
      xs: 'none',
      sm: 'rgba(67, 56, 202, 0.06)',
    },
    border: {
      xs: 'none',
      sm: '2px solid',
    },
    borderColor: {
      xs: 'unset',
      sm: 'primary.main',
    },
    borderRadius: '16px 16px 0 0',
    marginTop: '-16px',
    paddingTop: '32px',
    borderBottom: {
      xs: 'none',
      sm: 'none',
    },
    minHeight: {
      xs: 'unset',
      sm: '160px',
    },
  },
  recommendedChip: {
    borderRadius: '4px',
    fontWeight: 600,
    height: '24px',
    fontSize: '0.75rem',

    display: {
      xs: 'none',
      sm: 'flex',
    },
  },
})

export default styles
export type StylesClassNames = StylesClasses<typeof styles>
